import { render, staticRenderFns } from "./ReCallsObjSmall.vue?vue&type=template&id=d929c176&scoped=true"
import script from "./ReCallsObjSmall.vue?vue&type=script&lang=js"
export * from "./ReCallsObjSmall.vue?vue&type=script&lang=js"
import style0 from "./ReCallsObjSmall.vue?vue&type=style&index=0&id=d929c176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d929c176",
  null
  
)

export default component.exports